import React from 'react';
import { stats } from '../mock/data';

export const TrackRecord = () => {
  return (
    <section className="py-20 bg-white" data-testid="track-record-section">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-10 border border-slate-200">
          <h2 className="text-2xl lg:text-3xl font-bold text-slate-900 mb-8 text-center uppercase tracking-wide">Institutional Credentials</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat) => (
              <div key={stat.id} className="text-center p-4 bg-slate-50 rounded-xl">
                <div className="text-3xl font-bold text-emerald-600 mb-2">{stat.value}</div>
                <div className="text-sm text-slate-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
          <div className="mt-8 p-6 bg-emerald-50 rounded-xl border border-emerald-100">
            <p className="text-center text-slate-700 font-medium">
              Corporate finance advisory across debt, structured credit, asset-backed finance and strategic capital
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
